import { ContractType } from "../contract-control-detail-view/contract-type-dropdown/contract-type-dropdown.component";

export const contractTypes: ContractType[] = [{ id: 1, type: 'master contract' }, { id: 2, type: 'sub contract' }]

export enum ContractTypeEnum {
    MasterContract = 1,
    SubContract = 2
}